import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { FadeIn } from './FadeIn';
import { SectionHeader } from './SectionHeader';
import { AnimatedBackground } from './AnimatedBackground';
import { faqs } from '../data/faqs';
export function Faq() {
  const [activeId, setActiveId] = useState(faqs[0].id);
  const activeIndex = Math.max(faqs.findIndex(faq => faq.id === activeId), 0);
  const active = faqs[activeIndex];
  return <section id="faq" className="cv-auto relative w-full overflow-hidden bg-white px-6 py-24" data-id="element-34" data-mp="292o4uuhgk5wf">
      <AnimatedBackground intensity="light" icons data-id="element-35" data-mp="240fc9z8hz5uu" />

      <div className="relative mx-auto max-w-[1100px]" data-id="element-36" data-mp="1z3oxdf8figb0">
        <FadeIn data-id="element-37" data-mp="1z59pyzb6np68">
          <SectionHeader centered badge="FAQ" badgeIcon={<HelpOutlineIcon sx={{
          fontSize: 15
        }} data-id="element-39" data-mp="sl0ggys0yk1b" />} title="Preguntas frecuentes." data-id="element-38" data-mp="sn3eo63bzjh4" />
        </FadeIn>

        <FadeIn data-id="element-40" data-mp="pi7gsdo3cqlc">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:gap-11" data-id="element-41" data-mp="phoaju7szqn5">
            {/* Índice */}
            <div role="tablist" aria-label="Preguntas frecuentes" aria-orientation="vertical" className="relative flex w-full flex-col gap-3 lg:w-[404px] lg:flex-shrink-0" data-id="element-42" data-mp="ufzly9dqy97h">
              {faqs.map((faq, index) => {
              const isActive = faq.id === activeId;
              return <button key={faq.id} type="button" role="tab" id={`faq-tab-${faq.id}`} aria-selected={isActive} aria-controls="faq-answer-panel" onClick={() => setActiveId(faq.id)} className="relative flex items-center gap-3.5 rounded-2xl px-5 py-4 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2" data-id="element-43" data-mp="bhwpxams7c06" data-mpi={index}>
                    {isActive ? <motion.span layoutId="faq-index-indicator" aria-hidden="true" className="absolute inset-0 rounded-2xl border-2 border-brand-blue bg-brand-blue/[0.055] shadow-[0_10px_26px_rgba(27,77,204,0.14)]" transition={{
                  type: 'spring',
                  stiffness: 380,
                  damping: 34
                }} data-id="element-44" data-mp="1pq4ekbcn7us6" /> : null}

                    <span className={`relative z-10 flex h-[26px] w-[26px] flex-shrink-0 items-center justify-center rounded-full border-2 text-[11px] font-extrabold transition-colors duration-300 ${isActive ? 'border-brand-blue bg-brand-blue text-white' : 'border-line text-muted'}`} data-id="element-45" data-mp="23gre25q89opb">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className={`relative z-10 text-sm font-bold leading-snug transition-colors duration-300 ${isActive ? 'text-ink' : 'text-muted'}`} data-id="element-46" data-mp="33qit97que2vh">
                      {faq.question}
                    </span>
                  </button>;
            })}
            </div>

            {/* Panel de respuesta */}
            <div id="faq-answer-panel" role="tabpanel" aria-labelledby={`faq-tab-${active.id}`} className="relative min-h-[320px] w-full overflow-hidden rounded-[20px] border-2 border-brand-blue bg-white shadow-brand lg:h-[420px] lg:min-h-0" data-id="element-47" data-mp="3nft70g712dqy">
              <span aria-hidden="true" className="absolute inset-x-0 top-0 h-[5px] bg-[linear-gradient(90deg,#1B4DCC,#FFD500)]" data-id="element-48" data-mp="1x3n92yphy244" />

              <AnimatePresence mode="wait" data-id="element-49" data-mp="16oci7rl6wpdr">
                <motion.div key={active.id} initial={{
                opacity: 0,
                x: 18,
                y: 12
              }} animate={{
                opacity: 1,
                x: 0,
                y: 0
              }} exit={{
                opacity: 0,
                x: -18,
                y: -12
              }} transition={{
                duration: 0.35,
                ease: [0.16, 1, 0.3, 1]
              }} className="flex h-full flex-col justify-center gap-4 px-8 py-10 sm:px-11" data-id="element-50" data-mp="11rm1r35h3rrt">
                  <p className="inline-flex items-center gap-2 text-[11.5px] font-extrabold uppercase tracking-[0.08em] text-brand-blue" data-id="element-51" data-mp="j1e61643s3ln">
                    <span className="h-[7px] w-[7px] rounded-full bg-brand-yellow shadow-[0_0_0_4px_rgba(255,213,0,0.2)]" data-id="element-52" data-mp="xqtugfg5vwy6" />
                    Pregunta {String(activeIndex + 1).padStart(2, '0')} /{' '}
                    {String(faqs.length).padStart(2, '0')}
                  </p>

                  <h3 className="font-display text-[22px] font-extrabold leading-tight text-ink" data-id="element-53" data-mp="9llm033nqpj">
                    {active.question}
                  </h3>

                  <p className="text-[14.5px] leading-relaxed text-muted" data-id="element-54" data-mp="2gop0at8igu8n">
                    {active.answer}
                  </p>

                  {active.highlight ? <span className="mt-1 inline-flex w-fit items-center gap-1.5 rounded-full bg-brand-green/10 px-3 py-1.5 text-[11.5px] font-bold text-[#14803D]" data-id="element-55" data-mp="26ydhy1o2yii8">
                      <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-brand-green" data-id="element-56" data-mp="2uohoohwkeydg" />
                      {active.highlight}
                    </span> : null}
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}